<input
  [formControl]="formControl"
  [min]="minValue"
  [max]="maxValue"
  type="number" name="{{ name }}"
  class="form-control text-center {{ customClasses }}">
